import { render, staticRenderFns } from "./userVoicevercode.vue?vue&type=template&id=b51c2d08"
import script from "./userVoicevercode.vue?vue&type=script&lang=js"
export * from "./userVoicevercode.vue?vue&type=script&lang=js"
import style0 from "~/assets/css/login/userVoiceVercode.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports